@if (_layout == 'simple') {
  <div>
    <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
    </ng-container>
  </div>
}
@if (_layout == 'tab') {
  <div>{{_layout_id}}
    <ul class="base-tab">
      @for (layout_key of _layout_data | keys; track layout_key) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="layout_key == _currentData._layout_id ? 'active' : ''" (click)="activeTab(layout_key)" data-toggle="tab" id="{{layout_key}}" role="tab">{{_layout_data[layout_key]['data']['layoutName']}}</a>
        </li>
      }
    </ul>
    @if (this._currentData.render_template) {
      <div class="tab-content kx-h-tab p-3" id="_layout_id">
        <ng-container [ngTemplateOutlet]="layoutRenderer" [ngTemplateOutletContext]="{_currentData:_currentData}">
        </ng-container>
      </div>
    }
  </div>
}
<ng-template #layoutRenderer let-_currentData='_currentData'>
  @if ( (_currentData._currentFormFields.loaded == undefined ) || _currentData._currentFormFields.loaded) {
    @if (_currentData._currentFormFields && _currentAction == 'ADD') {
      <dhs-form [action]="'ADD'" [fieldGroup]="_currentData._currentFormFields" [qrCodedata]="_currentData.qrCodeData" [config]="_currentData.config" [customButton]="_currentData.customButton" [data]="_currentData.currentData" (saveFinished)="onSaveFinished($event, _currentData.resourceDef.application, _currentData.resourceDef.resource)"
        (cardData)="cardData($event)" [decorator]="_currentData.decorator" #formComponenet>
      </dhs-form>
    }
    @if (_currentData._currentFormFields && _currentAction == 'MODIFY' && _currentData.dataSet) {
      <dhs-form [action]="'MODIFY'"   [qrCodedata]="_currentData.qrCodeData" [fieldGroup]="_currentData._currentFormFields" [customButton]="_currentData.customButton" [config]="_currentData.config" [data]="_currentData.currentData"
        (saveFinished)="onSaveFinished($event, _currentData.resourceDef.application, _currentData.resourceDef.resource)" (cardData)="cardData($event)" [decorator]="_currentData.decorator" #formComponenet>
      </dhs-form>
    }
  }
</ng-template>
@if (_currentAction == 'LIST') {
  <div class="popup-form" [ngClass]="(data?.class_name)?(data.class_name):''">
    <!-- <app-ui-engine [resourcename]="_currentData.resourceDef.resource" [bannerJson]="_currentData.bannerJson" [showGridOnly]=true></app-ui-engine> -->
    @if (newDataList && resourceDef && resourceDef.list && resourceDef.list.fields) {
      <dhs-data-grid (checkboxaction)="checkboxaction($event)" [filterFieldGroup]="filterFields" (bindGrid)="bindDataToGrid($event)" [fields]="resourceDef.list.fields" [data]="newDataList" [bulkActionsConfig]="bulkaction" [config]="_currentData.configList" (onPageChanges)="pageChanged($event)"
        (checkBoxDataEmit)="onCheckBoxDataEmit($event)" (onFilterChange)="filterChange($event)" (onLimitChange)="limitChanged($event)"  (editEllipseClick)="buttonAction($event)" (bulkActionClicked)="onBulkActionClicked($event)">
      </dhs-data-grid>
    }
    @if (_currentData && _currentData.resourceDef && _currentData.resourceDef.btn && newDataList['resource'] && newDataList['resource'].length > 0) {
      <div class="composite-aside-btn col-sm-12 text-center mt-1 d-inline-block form-action-button-container">
        @for (btn of _currentData.resourceDef.btn; track btn) {
          <button type="submit" class="btn primary-btn aside-fixed-button" (click)="emitButtonInfo(btn)">
            {{ btn.label | translate | async }}
            @if (btn.icon!=undefined) {
              <i class="fa {{btn.icon}} ml-2" aria-hidden="true"></i>
            }
          </button>
        }
      </div>
    }
  </div>
}